import { ObjectMapper } from "json-object-mapper";
import { Model } from "../model";
import { IModel } from "../IModel";

export class FormSubmissionModel extends Model implements IModel<FormSubmissionModel> {
    public employeeId: string = "";
    public companyGroupId: string = "";
    public companyId: string = "";
    public completionDate: string = "";
    public dateEnd: string = "";
    public formTypeId: string = "";
    public status: string = "";
    public justification: string = "";
    public formType: FormSubmissionModel;
    public anonymousSubmission: boolean = false;
    static create(input: any): FormSubmissionModel {
        return ObjectMapper.deserialize<FormSubmissionModel>(FormSubmissionModel, input);
    }

    public toJSON(): string {
        return ObjectMapper.serialize(this) as string;
    }
}
